import { render, staticRenderFns } from "./EdgeInfos.vue?vue&type=template&id=57a010e0"
import script from "./EdgeInfos.vue?vue&type=script&lang=js"
export * from "./EdgeInfos.vue?vue&type=script&lang=js"
import style0 from "./EdgeInfos.vue?vue&type=style&index=0&id=57a010e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports